var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgAdComplaintSuccess = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("rect", {
    width: 54.5,
    height: 72.5,
    x: 20.75,
    y: 11.75,
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 3.25
  }), React.createElement("rect", {
    width: 8,
    height: 1.5,
    x: 57,
    y: 63.2,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 8.5,
    height: 1.5,
    x: 29,
    y: 56.7,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 24,
    height: 1.5,
    x: 29,
    y: 50.2,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 8,
    height: 1.5,
    x: 57,
    y: 50.2,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 24,
    height: 1.5,
    x: 41,
    y: 56.7,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 24,
    height: 1.5,
    x: 29,
    y: 63.2,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("path", {
    fill: color,
    d: "M29 73.45a2.75 2.75 0 0 1 2.75-2.75h14.5a2.75 2.75 0 1 1 0 5.5h-14.5A2.75 2.75 0 0 1 29 73.45Z"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M42.6 35.46a6.3 6.3 0 1 0-12.6 0 6.3 6.3 0 0 0 12.6 0Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m45.95 35.45 10.226-8.493"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M65.91 35.462a6.3 6.3 0 1 0-12.6 0 6.3 6.3 0 0 0 12.6 0Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M59.611 35.46c-5.835-9.875-.208-17.037-6.942-15.242"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M56.464 24.934h-12.6l-7.56 10.529 9.466.149M45.95 35.45l-2.648-13.231M41.45 22.174h4.04"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M70.5 89C78.508 89 85 82.508 85 74.5S78.508 60 70.5 60 56 66.492 56 74.5 62.492 89 70.5 89Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    stroke: "var(--color-neutral-70)",
    strokeWidth: 1.5,
    d: "M65.985 74.471a.449.449 0 0 0-.636 0 .452.452 0 0 0 0 .638l3 3.008a.45.45 0 0 0 .636 0l6.6-6.618a.452.452 0 0 0 0-.638.45.45 0 0 0-.636 0l-6.282 6.3-2.682-2.69Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M79.216 6H64.784C63.245 6 62 7.257 62 8.809v9.313c0 1.553 1.245 2.81 2.784 2.81h1.758c.22 0 .366.147.366.369v3.622c0 .296.367.444.587.222l4.102-4.14c.073-.074.147-.074.22-.074h7.4c1.538 0 2.783-1.256 2.783-2.809V8.81C82 7.183 80.755 6 79.216 6Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M69.2 17.539v-7.67c0-.08.032-.156.089-.213.079-.08.227-.178.455-.269.352-.14.806-.223 1.373-.223.555 0 .936.108 1.727.425.723.289 1.048.382 1.502.382.493 0 .87-.069 1.15-.18.09-.037.162-.074.215-.11l.036-.025a.303.303 0 0 1 .517.214v4.843c0 .08-.032.158-.089.215-.08.079-.227.177-.455.268-.352.141-.806.224-1.374.224-.555 0-.935-.109-1.727-.425-.722-.29-1.047-.382-1.502-.382-.492 0-.87.068-1.148.18a1.34 1.34 0 0 0-.163.077v2.669a.303.303 0 1 1-.606 0Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m69.289 9.656-.177-.177.177.177Zm.455-.269-.093-.232.093.232Zm3.1.202-.093.232.093-.232Zm2.651.202-.093-.232.093.232Zm.216-.11-.139-.208.139.208Zm.036-.025-.177-.177a.25.25 0 0 0 .354.354l-.177-.177Zm.428 5.271-.177-.176.177.177Zm-.455.27-.093-.233.093.232Zm-3.1-.202-.093.232.093-.232Zm-2.651-.202.092.232-.093-.232Zm-.163.077-.124-.218a.25.25 0 0 0-.126.218h.25Zm-.356 2.669v-7.67h-.5v7.67h.5Zm0-7.67c0-.013.006-.026.016-.036l-.354-.354a.553.553 0 0 0-.162.39h.5Zm.016-.036c.047-.048.162-.13.37-.214l-.185-.464a1.624 1.624 0 0 0-.539.324l.354.354Zm.37-.214c.316-.126.737-.205 1.281-.205v-.5c-.59 0-1.077.085-1.466.24l.186.465Zm1.281-.205c.507 0 .852.094 1.634.407l.186-.464c-.8-.32-1.216-.443-1.82-.443v.5Zm1.634.407c.729.291 1.091.4 1.595.4v-.5c-.404 0-.693-.078-1.409-.364l-.186.464Zm1.595.4c.514 0 .926-.072 1.242-.198l-.185-.464c-.241.096-.586.162-1.057.162v.5Zm1.242-.198a1.43 1.43 0 0 0 .262-.134l-.278-.416a.945.945 0 0 1-.17.086l.186.464Zm.262-.134a1.023 1.023 0 0 0 .045-.032l-.006.004a.264.264 0 0 1-.06.03.25.25 0 0 1-.313-.139.253.253 0 0 1 .036-.253l.018-.02.354.354.018-.02a.239.239 0 0 0 .037-.065.25.25 0 0 0-.232-.342.242.242 0 0 0-.11.025l-.02.011a.225.225 0 0 0-.013.009l-.006.004-.002.002c-.002 0-.003.002-.005.003a.462.462 0 0 1-.019.013l.278.416Zm.074-.056a.05.05 0 0 1 .027-.016c.008-.001.02 0 .03.004a.05.05 0 0 1 .033.049h.5a.553.553 0 0 0-.944-.39l.354.353Zm.09.037v4.843h.5V9.87h-.5Zm0 4.843a.053.053 0 0 1-.016.038l.354.353a.553.553 0 0 0 .162-.39h-.5Zm-.016.038c-.047.047-.162.13-.37.213l.185.464c.247-.098.428-.213.539-.324l-.354-.353Zm-.37.213c-.316.126-.737.206-1.282.206v.5c.59 0 1.078-.086 1.467-.242l-.186-.464Zm-1.282.206c-.506 0-.851-.095-1.634-.408l-.185.465c.8.32 1.216.443 1.82.443v-.5Zm-1.634-.408c-.728-.291-1.09-.4-1.595-.4v.5c.405 0 .693.078 1.41.365l.185-.465Zm-1.595-.4c-.513 0-.925.072-1.241.199l.185.464c.241-.096.585-.162 1.056-.162v-.5Zm-1.241.199c-.073.029-.138.06-.194.091l.247.435c.034-.02.078-.04.132-.062l-.185-.464Zm-.32.309v2.669h.5v-2.67h-.5Zm0 2.669c0 .029-.024.052-.053.052v.5a.553.553 0 0 0 .553-.552h-.5Zm-.053.052a.053.053 0 0 1-.053-.052h-.5c0 .305.248.552.553.552v-.5Z"
  }));
};
export default SvgAdComplaintSuccess;